import { vuexPto } from '@/store/compositionV2/module/pto'
import { PtoStatementApi } from '@/api/pto'
import { updateItemSelect } from '@/store/compositionV2/utils/data/actions'
import { prepareProjectStatementFormData } from '@/utils/page/pto/project'
import { mapJobItem } from '@/utils/page/pto/project/pto/map'
import { getYesOrNo } from '@/utils/string/getYesOrNo'
import { vuexSaveItemAndFiles } from '@/store/compositionV2/saveItemAndFiles'
import { vuexFileBase } from '@/store/compositionV2/utils/file'
import router from '@/router'
import { EAppTableMod } from '@/components/page/table/types'

function getRouteEstimateUpdate (item) {
  return {
    name: 'PtoProjectEstimateUpdate',
    params: {
      id: item.id,
      projectId: router.currentRoute.params.projectId
    }
  }
}

const state = () => ({
  ...vuexPto.createState(),
  ...vuexFileBase.createState(),
  api: PtoStatementApi,
  namePageDetailed: 'PtoProjectStatementUpdate',
  prepareFormData: prepareProjectStatementFormData,
  expand: 'files,jobs,type,estimates',
  tableHeaders: [
    {
      title: '№ ведомости',
      isSortable: true,
      sortName: 'number'
    },
    {
      title: 'Дата создания',
      isSortable: true,
      sortName: 'create_date'
    },
    {
      title: 'Тип',
      isSortable: true,
      sortName: 'type.name'
    },
    {
      title: 'Письмо Интекс',
      isSortable: true,
      sortName: 'intex_letter'
    },
    {
      title: 'Письмо подрядчика',
      isSortable: true,
      sortName: 'contractor_letter'
    },
    {
      title: '№ письма заказчика',
      isSortable: true,
      sortName: 'customer_letter'
    },
    {
      title: '№ сметы',
      isSortable: false,
      sortName: ''
    },
    {
      title: 'Нет сметы',
      isSortable: false,
      sortName: 'is_no_estimate'
    },
    {
      title: 'Вложения',
      isSortable: false
    },
    {
      title: 'Примечание',
      isSortable: true,
      sortName: 'note'
    }
  ]
})

const getters = {
  ...vuexPto.createGetters(),
  ...vuexFileBase.createGetters(),
  getList: (state, _, rootState) => {
    const typeList = rootState.handbook.pto.statementTypeList
    return state.list.map(item => {
      let filesCount = {
        count: '0 файлов'
      }
      if (item.files) {
        filesCount = {
          count: item.files.length + ' файлов'
        }
      }

      const estimates = {
        mod: EAppTableMod.links,
        data: item.estimates?.map(item => ({
          id: item.id,
          text: item.estimate
        })) || [],
        getRouteHandler: getRouteEstimateUpdate
      }

      return {
        isControlsActive: item.isControlsActive,
        isActive: item.isActive,
        id: item.id,
        values: [
          item.number || '-',
          item.create_date || '-',
          { data: item.type || '-', name: 'type', list: typeList, mod: 'select' },
          item.intex_letter || '-',
          item.contractor_letter || '-',
          item.customer_letter || '-',
          estimates,
          getYesOrNo(!item.estimates?.length),
          { data: filesCount, mod: 'countFiles' },
          { data: item.note || '-', mod: 'comments' }
        ]
      }
    })
  },
  getCurrentItem: state => ({
    ...state.currentItem,
    jobs: state.currentItem.jobs?.length ? state.currentItem.jobs.map(mapJobItem) : []
  })
}

const mutations = {
  ...vuexPto.createMutations(),
  ...vuexFileBase.createMutations()
}

const actions = {
  ...vuexPto.createActions(),
  ...vuexSaveItemAndFiles.createActions(),
  updateItemSelect
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
